"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TooltipAction = _interopRequireDefault(require("./TooltipAction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowDown = function ArrowDown(_ref) {
  var columnSections = _ref.columnSections,
      current = _ref.current,
      onDivisionSummary = _ref.onDivisionSummary,
      interval = _ref.interval;
  var items = [];

  for (var i = 0; i < columnSections; i++) {
    items.push( /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "vertical-line",
      style: {
        width: "".concat(100 / columnSections, "%"),
        borderBottom: current ? 'solid 3px #E9643F' : ''
      }
    }, /*#__PURE__*/_react["default"].createElement(_TooltipAction["default"], {
      onDivisionSummary: onDivisionSummary,
      timeAprox: getTimeAprox(interval, columnSections, i)
    })));
  }

  return items;
};

var _default = ArrowDown;
exports["default"] = _default;

var getTimeAprox = function getTimeAprox(interval, section, index) {
  if (interval) {
    var totalTime = Date.parse(interval.end) - Date.parse(interval.begin);
    return new Date(Date.parse(interval.begin) + totalTime / section * index);
  } else return undefined;
};